import { path } from 'ramda';
import React from 'react';
import styled from 'styled-components';

import { Icon } from '@ui/icons/Icon.tsx';
import PillLabel from '@ui/labels/PillLabel.tsx';

import { useCSSColors } from '../../hooks/useCSSColors.ts';

const StyledPillLabel = styled(PillLabel)`
  padding-inline-start: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;

  div {
    margin-inline-start: 3px;
  }
`;

interface SecurityLabelProps {
  poi: Record<string, unknown>;
  T: (key: string) => string;
  className?: string;
  statusText?: string;
}

const SecurityLabel = ({ poi, className, statusText }: SecurityLabelProps) => {
  const colors = useCSSColors();
  const dynamicData = path(['dynamicData', 'security'], poi);

  if (!dynamicData) {
    return null;
  }
  const { isTemporarilyClosed } = dynamicData as Record<string, unknown>;
  const shouldShowIcon = !isTemporarilyClosed;

  const backgroundColor = isTemporarilyClosed ? colors.statusClosedBackground : colors.statusCancelledBackground;

  const color = isTemporarilyClosed ? colors.statusClosedText : colors.statusCancelledText;

  return (
    <StyledPillLabel $backgroundColor={backgroundColor} $color={color} className={className}>
      {shouldShowIcon && <Icon name="opening-hours" cdn width={20} height={20} fillColor="white" />}
      {statusText}
    </StyledPillLabel>
  );
};

export { SecurityLabel };
